import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {WorkV4} from '../types';
import {selectMetadataEditSavedWorkSelector} from '../metadataEditSlice';

export const useAssertSavedWork = (): WorkV4 => {
  const work = useAppSelector(selectMetadataEditSavedWorkSelector);
  return assert(work, 'useAssertSavedWork: no work');
};
